import React, { useState, useEffect, useContext } from 'react';
import konsole from '../../network/konsole';
import Services from '../../network/Services';
import commonLib from '../../control/commonLib';
import { UserContext } from "../../App.js";
import { ViewandupdateNewModal } from './ViewandupdateNewModal.js';
import "./communication.css"

function CommunicationNewTable(props) {

  const [showAddModal, setShowAddModal] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState([])
  const [subtenantID, setSubtenantID] = useState()
  const [emptyState, setEmptyState] = useState()
  const [updateTableData, setupdateTableData] = useState(false)
  const [inblidEmailTemplate, setInblidEmailTemplate] = useState([])
  const [sortedData, setsortedData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10

  let userId = commonLib.getObjFromStorage("stateObj").userId
  const { setLoader } = useContext(UserContext)

  useEffect(() => {
    let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
    setSubtenantID(subtenantIDd)
  }, [])

  useEffect(() => {
    let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
    if (updateTableData == true) {
      props.GetCommMediumPathApiFuction(subtenantIDd)
      setupdateTableData(false)
    }
  }, [updateTableData])

  useEffect(() => {
    if (subtenantID && !updateTableData) getEmailTemplatesPathApiFunction(subtenantID)
  }, [subtenantID, selectedRowData?.applicableEmailTempId, updateTableData])

  const handleClose = () => {
    setEmptyState({})
    props.GetCommMediumPathApiFuction(subtenantID)
    getEmailTemplatesPathApiFunction(subtenantID)
    setShowAddModal(false);
  }

  useEffect(() => {
    let newData = props.GetCommMediumData.sort((a, b) => a.screenName.localeCompare(b.screenName));
    setsortedData(props.GetCommMediumData)
    setCurrentPage(1)
  }, [props.GetCommMediumData])

  const addEditModalFun = (rowData) => {
    setShowAddModal(true)
    setSelectedRowData(rowData)
  }

  const getEmailTemplatesPathApiFunction = (subtenantID) => {
    const promises = Services.getEmailTemplatesPathApi(subtenantID)
    promises.then((response) => {
      setInblidEmailTemplate(response?.data?.data);
    }).catch((error) => {
      konsole.log("error", error);
    }).finally(() => {
      konsole.log("finish");
    });
  };

  const PutUpsertCommMediumApiFuctioniOnOFF = (e, rowOnOffData) => {
    setLoader(true)
    const obj = {
      "subtenantId": subtenantID,
      "applicableConId": rowOnOffData?.applicableConId,
      "screenId": rowOnOffData?.screenId,
      "isActive": e.target.checked,
      "upsertedBy": userId,
      "commMediumId": rowOnOffData?.commMediumId
    }
    const promises = Services.postUpsertCommMediumApi(obj)
    promises.then((response) => {
      handleClose();
      setLoader(false)
    }).catch((error) => {
      konsole.log("error", error);
      setLoader(false)
    }).finally(() => {
      konsole.log("finish");
    });
  }

  const filteredData = sortedData
    ? sortedData?.filter(d => d?.screenName?.toLowerCase().includes(props?.search?.toLowerCase()))
    : [];

  const totalPages = Math.ceil(filteredData.length / pageSize)
  const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  // const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '14px', background: '#fff', textAlign: 'start', padding: '8px' }
  // const dtBodyStyle = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '8px' }
  // const dtBodyStyleCenter = { color: '#333', fontSize: '13px', background: '', textAlign: 'center', fontWeight: 100, padding: '8px' }

  const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '14px', background: '#fff', textAlign: 'start', padding: '6px 8px' }
  const dtBodyStyle = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '6px 8px', verticalAlign: 'middle' }
  const dtBodyStyleCenter = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '6px 8px', verticalAlign: 'middle' }

  return (
    <>
      <div style={{ border: '1px solid #ddd', marginTop: '12px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
          <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: 'Open Sans, sans-serif', fontSize: '13px' }}>
            <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
              <tr>
                <th style={dtHeaderStyle}>Status</th>
                <th style={dtHeaderStyle}>Template Name</th>
                <th style={dtHeaderStyle}>Screen Name</th>
                <th style={dtHeaderStyle}>Sub Screen Name</th>
                <th style={dtHeaderStyle}>Template</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0
                ? paginatedData.map((data) => (
                  <tr key={data?.applicableConId || data?.screenId}>
                    <td style={dtBodyStyle}>
                      <div className='d-flex justify-content-center align-items-center' style={{ marginTop: '2px' }}>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            defaultChecked={data?.isActive}
                            onClick={(e) => PutUpsertCommMediumApiFuctioniOnOFF(e, data)}
                          />
                          <span className="switch-label" data-on="On" data-off="Off"></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </td>
                    <td style={dtBodyStyle}>{data.screenName}</td>
                    <td style={dtBodyStyleCenter}>{data?.moduleSectionName}</td>
                    <td style={dtBodyStyleCenter}>{data?.moduleSubSection}</td>
                    <td style={dtBodyStyle}>
                      <span
                        style={{ cursor: 'pointer', color: '#720c20', fontWeight: 500 }}
                        onClick={() => addEditModalFun(data)}
                      >
                        View
                      </span>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No matching records found.</td></tr>
              }
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #ddd', background: '#fff' }}>
          <span style={{ fontSize: '13px', color: '#555' }}>
            Showing {filteredData?.length === 0 ? 0 : (currentPage - 1) * pageSize + 1} to {Math.min(currentPage * pageSize, filteredData?.length)} of {filteredData.length} entries
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <button
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}
            >‹</button>

            {(() => {
              const pages = [];
              for (let p = 1; p <= totalPages; p++) {
                if (p === 1 || p === totalPages || (p >= currentPage - 1 && p <= currentPage + 1)) {
                  pages.push(p);
                }
              }
              const result = [];
              pages.forEach((p, i) => {
                if (i > 0 && p - pages[i - 1] > 1) result.push('ellipsis-' + p);
                result?.push(p);
              });
              return result.map((p) =>
                String(p).startsWith('ellipsis')
                  ? <span key={p} style={{ padding: '0 4px', fontSize: '13px' }}>...</span>
                  : <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    style={{
                      width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px',
                      background: currentPage === p ? '#720c20' : '#fff',
                      color: currentPage === p ? '#fff' : '#555',
                      cursor: 'pointer', fontSize: '13px'
                    }}
                  >{p}</button>
              );
            })()}

            <button
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: (currentPage === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer', color: '#555' }}
            >›</button>
          </div>
        </div>
      </div>

      {showAddModal &&
        <ViewandupdateNewModal
          selectedRowData={selectedRowData}
          inblidEmailTemplate={inblidEmailTemplate}
          showAddModal={showAddModal}
          setShowAddModal={setShowAddModal}
          GetCommMediumPathApiFuction={props.GetCommMediumPathApiFuction}
          setupdateTableData={setupdateTableData}
        />
      }
    </>
  );
}

export default CommunicationNewTable;
